var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400.62 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #282828;\n        opacity: .7;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #329e51;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "72 0 72 8 8.36 8 8.36 68 0 68 0 0 72 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "399.62 8 399.62 98.76 365.38 133 8.38 133 8.38 8 399.62 8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuButton);
export default __webpack_public_path__ + "static/media/menu_button.2f80b0aa0f5e401c434a92a93067bfd8.svg";
export { ForwardRef as ReactComponent };